import TubCommon from "./tubCommon";
import {Shower} from "../../parts/shower";
import {createParentPositions, LOOK_ROOM_TYPES, METADATA, ShowerHeadTypes} from "../../constants";
import {getCurrentRoomType} from "../../../../appLayout";

export default class ReplacementTubFixture extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'replacement_tub_fixture';
    this.visible = true;
    this.partName = 'Replacement Tub Fixture';
    this.dbName = 'Replacement tub Fixture';
    this.translateId = "visualizer.bathroom.shower_tub_combo.replacement_tub_fixture";
    this.bottomTubId = "replacement_tub";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Side"] || (Array.isArray(dbFeature.metaData["Side"]) && dbFeature.metaData["Side"][0] === "0")) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    if (Array.isArray(dbFeature.metaData["ShowerSize"]) && dbFeature.metaData["ShowerSize"].includes("0")) {
      dbFeature.metaData["ShowerSize"] = [METADATA.ALL];
    }
    return super.load(dbFeature)
  }

  handleClick() {
    const showerTubComboParent = this.getParent().getParent();
    const showerParent = showerTubComboParent.layout.parts["Shower"];
    showerParent.setShowerHeadType(ShowerHeadTypes.shower_fixture);
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      if (Array.isArray(this.metaData["MountType"]) && this.metaData["MountType"].includes("S")
        && ((showerParent.shower_head_type === ShowerHeadTypes.shower_arm && showerParent.showerArm && !showerParent.showerArm.disabled)
          || (showerParent.shower_head_type === ShowerHeadTypes.shower_head_bundle && showerParent.showerHeadBundle && !showerParent.showerHeadBundle.disabled))) {
        // store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.notCompatiblePopup));
        // return;
        this.applyFeatureIfNotCompatible();
      }
      if (showerTubComboParent.showerTubComboIsActive
        && showerParent.showerFixture?.activeFeature && !showerParent.showerFixture.disabled) {
        showerParent.showerFixture.disabled = true;
      }
    }
    super.handleClick();
  }

  applyFeatureIfNotCompatible() {
    const showerParent = this.getParent().getParent();
    if (showerParent.showerArm) {
      showerParent.showerArm.disabled = true;
    }
    if (showerParent.showerHead) {
      showerParent.showerHead.disabled = true;
    }
    if (showerParent.showerHeadBundle) {
      showerParent.showerHeadBundle.disabled = true;
    }
  }

  hideLayerCondition() {
    const showerTubComboParent = this.getParent();
    const showerParent = showerTubComboParent.layout.parts["Shower"];
    if (!showerTubComboParent.showerTubComboIsActive
      && !(showerTubComboParent && showerTubComboParent.freeStandingTubActive())) {
      return true
    }
    if (showerTubComboParent.bottomTub === "walk_in_tub") {
      return true // they don't have repl tub fixture
    }
    if (showerParent.showerFixture?.activeFeature && !showerParent.showerFixture.disabled) {
      return true
    }
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_fixture && this.activeFeature
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    // const showerComboParent = this.getParent();
    // if (showerComboParent.replacementTub && showerComboParent.replacementTub.activeFeature
    //   && !showerComboParent.replacementTub.disabled) {
    //   conditions.push({
    //     propName: "MatchingFeature",
    //     propValue: showerComboParent.replacementTub.activeFeature.metaData["ActualDisplayedName"]
    //   });
    // } else if (showerComboParent.walkInTub && showerComboParent.walkInTub.activeFeature
    //   && !showerComboParent.walkInTub.disabled) {
    //   conditions.push({
    //     propName: "MatchingFeature",
    //     propValue: showerComboParent.walkInTub.activeFeature.metaData["ActualDisplayedName"]
    //   });
    // }
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerParent && showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    return conditions
  }

}
